export function convertToStandardTime(militaryTime) {
  const [hours, minutes] = militaryTime.split(':');
  const period = hours >= 12 ? 'PM' : 'AM';
  const standardHours = hours % 12 || 12;
  return `${standardHours}:${minutes} ${period}`;
}

export function permissionsToCheck(perm, permissionsArr) {
  const findPerm = permissionsArr.find(
    (permission) => permission.includes(perm)
    // (permission) => permission === "authorization:role:view"
  );
  const hasPermission = findPerm ? true : false;
  // console.log("Has Permission:", perm, hasPermission);
  return hasPermission;
};

export function simplifyOrgName(orgName) {
  if (orgName === "Maximus Canada DEV" || orgName === "maximuscanada-dev")
    return "DEV";
  if (orgName === "Maximus Canada FEC" || orgName === "maximuscanada-fec")
    return "FEC";
  if (
    orgName === "Maximus Canada SBC Internal CC" ||
    orgName === "maximuscanada-sbc-internalcc"
  )
    return "ICC";
  if (orgName === "Maximus Canada Service Desk" || orgName === "maximuscanada-servicedesk")
    return "MAX";
  if (orgName === "Maximus Canada ODB" || orgName === "maximuscanada-odb")
    return "ODB";
  if (orgName === "Maximus Canada" || orgName === "maximuscanada") return "SBC";
  if (
    orgName === "Maximus Canada SBC SDO" ||
    orgName === "maximuscanada-sbc-sdo"
  )
    return "SDO";
  if (orgName === "Maximus Canada Service Timmins" || orgName === "maximuscanada-service-timmins")
    return "TIM";
};


